export default __webpack_public_path__ + "static/media/insta-5-comp.79fefad0.jpg";